import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import BaseModal, { BaseModalActions, BaseModalContent } from "./BaseModal";
import { getError, getErrorTitle } from "../../store/layout/selector";
import Text from "../Text/Text";
import { hideErrorMessage } from "../../store/layout/action";

const useStyles = makeStyles((theme) => ({
  okButton: {
    background: theme.palette.error.main,
    color: theme.palette.primary.contrastText,
    "&:hover": {
      background: theme.palette.error.light,
    },
  },
  header: {
    background: theme.palette.error.main,
  },
}));

const ErrorModal = () => {
  const classes = useStyles();
  const errorData = useSelector(getError);
  const title = useSelector(getErrorTitle);
  const dispatch = useDispatch();
  let errorMessage = errorData && errorData?.data;
  let status = errorData && errorData?.status;

  const handleOk = () => {
    dispatch(hideErrorMessage());
  };

  let message =
    errorMessage &&
    (errorMessage?.error_description ||
      errorMessage.error ||
      errorMessage?.errorMessage ||
      errorMessage?.errorMessages ||
      errorMessage?.message
      );

  if (status === 500) {
    message = "Something is wrong.";
  }

  const getMessage = (title) => {
    if (title === "Registration Failed") {
      return (
        <Text color="error">
          <b>{title} : </b>
          {errorData?.data?.errorMessages}
        </Text>
      );
    } else if (title === "Login Failed") {
      return (
        <Text color="error">
          <b>{title} : </b>
          {"Invalid username and password. Please try again."}
        </Text>
      );
    } else if (title === 'Alert'){
      return (
        <Text color='error'>
          {"Permit must be Associated with at least 1 Vehicle"}
        </Text>
      )
    } else {
      return <Text color="error">{message || "Something is wrong."}</Text>;
    }
  };

  return (
    <>
      {message ? (
        <BaseModal
          open={!!errorData}
          title={title || "Error"}
          className={classes.header}
        >
          <BaseModalContent>
            {getMessage(title)}
          </BaseModalContent>
          <BaseModalActions>
            <Button
              onClick={handleOk}
              variant="contained"
              className={classes.okButton}
            >
              Ok
            </Button>
          </BaseModalActions>
        </BaseModal>
      ) : (
        ""
      )}
    </>
  );
};

export default ErrorModal;
